module.exports = __webpack_public_path__ + "img/45.7.Chla.27698498.png";